<form
  *ngIf="form && initialized"
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="p-fluid">
  <app-header icon="fas fa-palette" text="Farben"></app-header>
  <div class="grid">
    <app-colorset-dropdown
      [colSize]="5"
      [fallback]="defaultsService.generalFallback()"
      formControlName="colorset"></app-colorset-dropdown>
  </div>

  <p-divider />
  <app-header
    text="Sortierung"
    icon="fas fa-arrow-down-wide-short"></app-header>
  <div formGroupName="sort" class="grid">
    <app-form-field-wrapper
      [floatingLabel]="false"
      [hideLabel]="true"
      [name]="'enable'"
      [colSize]="12">
      <p-checkbox
        formControlName="enable"
        [binary]="true"
        label="Sortierung anpassen"></p-checkbox>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Sortieren'"
      [hideLabel]="true"
      [floatingLabel]="false"
      [name]="'property'"
      [styleClass]="!form.value.sort.enable ? 'disabled' : ''"
      [colSize]="4">
      <div class="field-checkbox">
        <p-radioButton
          inputId="bar_sort_label"
          value="label"
          formControlName="property" />
        <label for="bar_sort_label" class="ml-2"> Gruppe </label>
      </div>
      <div class="field-checkbox">
        <p-radioButton
          inputId="bar_sort_value"
          value="value"
          formControlName="property" />
        <label for="bar_sort_value" class="ml-2"> Wert </label>
      </div>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [label]="'Auf-/ Absteigend'"
      [name]="'direction'"
      [styleClass]="!form.value.sort.enable ? 'disabled' : ''"
      [hideLabel]="true"
      [floatingLabel]="false"
      [colSize]="4">
      <div class="field-checkbox">
        <p-radioButton
          inputId="bar_direction_asc"
          value="asc"
          formControlName="direction" />
        <label for="bar_direction_asc" class="ml-2"> aufsteigend </label>
      </div>
      <div class="field-checkbox">
        <p-radioButton
          inputId="bar_direction_desc"
          value="desc"
          formControlName="direction" />
        <label for="bar_direction_desc" class="ml-2"> absteigend </label>
      </div>
    </app-form-field-wrapper>
  </div>

  <p-divider />
  <div>
    <app-header
      styleClass="-mb-4"
      text="Anzeigemodus"
      icon="fas fa-cubes-stacked"></app-header>
    <div class="grid align-items-baseline">
      <app-form-field-wrapper name="mode" [colSize]="6">
        <p-dropdown
          formControlName="mode"
          [options]="[
            {
              icon: 'fas fa-chart-column',
              label: 'Säulen (vertikal)',
              value: 'vertical',
            },
            {
              icon: 'fas fa-chart-bar',
              label: 'Balken (horizontal)',
              value: 'horizontal',
            },
          ]">
          <ng-template let-selectedItem pTemplate="selectedItem">
            <app-dropdown-option [item]="selectedItem" />
          </ng-template>
          <ng-template let-item pTemplate="item">
            <app-dropdown-option [item]="item" />
          </ng-template>
        </p-dropdown>
      </app-form-field-wrapper>

      <app-form-field-wrapper
        styleClass="mt-4"
        [floatingLabel]="false"
        [hideLabel]="true"
        name="stacked"
        [colSize]="6">
        <p-checkbox
          formControlName="stacked"
          [binary]="true"
          label="Diagramm stapeln"></p-checkbox>
      </app-form-field-wrapper>
    </div>
  </div>

  <p-divider />

  <app-header
    icon="fas fa-a"
    text="Balken- und Achsenbeschriftung"></app-header>
  <div class="grid">
    <app-form-field-wrapper
      [floatingLabel]="false"
      [hideLabel]="true"
      [name]="'caption'"
      [colSize]="5">
      <div class="flex gap-4">
        <p-radioButton
          name="caption"
          value="name"
          label="Name einblenden"
          formControlName="caption"
          inputId="caption" />
        <p-radioButton
          name="caption"
          value="key"
          label="Schlüssel einblenden"
          formControlName="caption"
          inputId="caption" />
      </div>
    </app-form-field-wrapper>
    <app-form-field-wrapper
      [hideLabel]="true"
      [floatingLabel]="false"
      [name]="'displayValues'"
      [colSize]="6">
      <p-checkbox
        [binary]="true"
        label="Werte einblenden"
        name="displayValues"
        formControlName="displayValues"></p-checkbox>
    </app-form-field-wrapper>
  </div>
</form>
